// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"5605708f","415":"bf444411"}[chunkId] + ".chunk.js";
};